export const formEmptyValidation = (values: Record<string, string>): Record<string, string> => {
  return Object.entries(values).reduce((errors, [key, value]) => {
    if (value.trim() === "") {
      errors[key] = "This field is required";
    }
    return errors;
  }, {} as Record<string, string>);
};
